import { useEffect, useState } from "react";
import API from "@/lib/api";
import { Reveal, Eyebrow } from "./Reveal";

const TIER_LABEL = { title: "টাইটেল স্পনসর", patron: "প্যাট্রন", well_wisher: "শুভানুধ্যায়ী" };

export default function SponsorsStrip() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    API.get("/sponsors")
      .then(({ data }) => setSponsors(data))
      .catch(() => {});
  }, []);

  if (!sponsors.length) return null;

  return (
    <section className="py-16 border-t border-[#F2B134]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center">
          <Eyebrow>আমাদের স্পনসররা · SPONSORS</Eyebrow>
          <div className="mt-10 flex flex-wrap justify-center gap-5">
            {sponsors.map((s) => (
              <div
                key={s.id}
                data-testid={`sponsor-${s.id}`}
                className="rounded-2xl border border-[#F2B134]/20 bg-[#1E0A0E] px-8 py-6 min-w-[220px] max-w-xs hover:border-[#F2B134]/50 hover:-translate-y-1 transition-all duration-300"
              >
                {s.logo_url ? (
                  <img src={s.logo_url} alt={s.name} className="mx-auto h-14 object-contain" />
                ) : (
                  <span className="mx-auto h-14 w-14 rounded-full grid place-items-center text-xl font-bold text-[#2A0A0E] bg-[linear-gradient(135deg,#FFE9A8,#F2B134_55%,#D99A1F)]">
                    {s.name.slice(0, 1)}
                  </span>
                )}
                <p className="font-bengali font-bold text-[#FDF6EA] mt-4">{s.name}</p>
                <p className="text-[10px] uppercase tracking-[0.22em] text-[#F2B134]/80 mt-1">{TIER_LABEL[s.tier] || s.tier}</p>
                {s.message && <p className="text-xs text-[#D1BBA7]/70 mt-2 font-bengali">{s.message}</p>}
                {s.website && (
                  <a href={s.website} target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-xs text-[#D1BBA7] hover:text-[#F2B134] underline decoration-[#F2B134]/40">
                    ওয়েবসাইট →
                  </a>
                )}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
